import { State as auth } from './auth/state'

export interface RootState {
  auth: auth
}

export default () => ({})
